import React, { useState } from 'react';
import Navigation from './Navigation';

const DashboardPage = ({ 
  currentUser, 
  currentPage, 
  setCurrentPage, 
  cart, 
  products, 
  purchases, 
  logout, 
  updateUser 
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [username, setUsername] = useState(currentUser.username);
  const [email, setEmail] = useState(currentUser.email);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const userProducts = products.filter(p => p.sellerId === currentUser.id);
  const totalEarnings = userProducts.reduce((sum, product) => sum + product.price, 0);
  const totalSpent = purchases.reduce((sum, item) => sum + item.price, 0);

  const handleSave = () => {
    if (!username.trim()) {
      setError('Username is required');
      return;
    }
    if (!email.trim()) {
      setError('Email is required');
      return;
    }

    updateUser({ username: username.trim(), email: email.trim() });
    setIsEditing(false);
    setError('');
    setSuccess('Profile updated successfully!');
    
    setTimeout(() => setSuccess(''), 3000);
  };

  const handleCancel = () => {
    setUsername(currentUser.username);
    setEmail(currentUser.email);
    setIsEditing(false);
    setError('');
  };

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <Navigation 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          cart={cart}
          logout={logout}
        />
      </div>
      
      <div className="form">
        <h2>User Dashboard</h2>
        
        <div style={{textAlign: 'center', margin: '20px 0'}}>
          <div className="profile-avatar">
            👤
          </div>
        </div>
        
        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}
        
        {isEditing ? (
          <>
            <label style={{display: 'block', margin: '10px 0 5px 0', fontWeight: 'bold'}}>
              Username
            </label>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              maxLength="50"
            />
            
            <label style={{display: 'block', margin: '10px 0 5px 0', fontWeight: 'bold'}}>
              Email Address
            </label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            
            <div style={{marginTop: '20px'}}>
              <button onClick={handleSave}>
                Save Changes
              </button>
              <button onClick={handleCancel} style={{background: '#666'}}>
                Cancel
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={{marginBottom: '20px'}}>
              <p style={{margin: '10px 0'}}><strong>Username:</strong> {currentUser.username}</p>
              <p style={{margin: '10px 0'}}><strong>Email:</strong> {currentUser.email}</p>
            </div>
            
            <div style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: '15px',
              margin: '20px 0'
            }}>
              <div style={{background: '#f9f9f9', padding: '15px', borderRadius: '8px', textAlign: 'center'}}>
                <h3 style={{color: '#2c5530', margin: '0 0 10px 0'}}>Products Listed</h3>
                <p style={{fontSize: '24px', fontWeight: 'bold', color: '#2c5530'}}>
                  {userProducts.length}
                </p>
              </div>
              
              <div style={{background: '#f9f9f9', padding: '15px', borderRadius: '8px', textAlign: 'center'}}>
                <h3 style={{color: '#2c5530', margin: '0 0 10px 0'}}>Items Purchased</h3>
                <p style={{fontSize: '24px', fontWeight: 'bold', color: '#2c5530'}}>
                  {purchases.length}
                </p>
              </div>
              
              <div style={{background: '#f9f9f9', padding: '15px', borderRadius: '8px', textAlign: 'center'}}>
                <h3 style={{color: '#2c5530', margin: '0 0 10px 0'}}>Potential Earnings</h3>
                <p style={{fontSize: '24px', fontWeight: 'bold', color: '#2c5530'}}>
                  ${totalEarnings.toFixed(2)}
                </p>
              </div>
              
              <div style={{background: '#f9f9f9', padding: '15px', borderRadius: '8px', textAlign: 'center'}}>
                <h3 style={{color: '#2c5530', margin: '0 0 10px 0'}}>Total Spent</h3>
                <p style={{fontSize: '24px', fontWeight: 'bold', color: '#2c5530'}}>
                  ${totalSpent.toFixed(2)}
                </p>
              </div>
            </div>
            
            <button onClick={() => setIsEditing(true)}>
              Edit Profile
            </button>
          </>
        )}
        
        <div style={{marginTop: '30px', padding: '15px', background: '#e8f5e8', borderRadius: '8px'}}>
          <h3 style={{color: '#2e7d32', margin: '0 0 10px 0'}}>🌱 Sustainability Impact</h3>
          <p style={{margin: '5px 0', color: '#2e7d32'}}>
            • You've helped {purchases.length} items find new homes
          </p>
          <p style={{margin: '5px 0', color: '#2e7d32'}}>
            • You've listed {userProducts.length} items for reuse
          </p>
          <p style={{margin: '5px 0', color: '#2e7d32'}}>
            • Contributing to a circular economy!
          </p>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;